import apiClient from './client';
import { API_BASE_URL } from '@/config/app';

export interface ImportU8Result {
  year: number;
  month: number;
  summary: string;
  debit_total: number;
  credit_total: number;
  balance_diff: number;
  entry_count: number;
  api_status: string;
  api_message: string;
  voucher_no?: string;
}

export interface ImportU8Response {
  success: boolean;
  message: string;
  total_rows: number;
  results: ImportU8Result[];
}

export interface U8ImportLogItem {
  id: number;
  year: number;
  month: number;
  business_type: string;
  company: string;
  voucher_no: string;
  summary: string;
  debit_total: number;
  credit_total: number;
  balance_diff: number;
  entry_count: number;
  total_rows: number;
  api_status: string;
  api_message: string;
  imported_by: number;
  imported_at: string;
}

export interface U8ImportHistoryResponse {
  data: U8ImportLogItem[];
  total: number;
  page: number;
  page_size: number;
}

export const importU8Api = {
  generate: async (year: number, businessType: string, company: string, month?: number): Promise<ImportU8Response> => {
    const body: Record<string, any> = {
      year,
      business_type: businessType,
      company,
    };
    if (month !== undefined && month !== null) {
      body.month = month;
    }
    const response = await apiClient.post<ImportU8Response>('/import-u8/generate', body);
    return response.data;
  },

  getExportUrl: (year: number, businessType: string, company: string, month?: number): string => {
    const token = localStorage.getItem('access_token');
    let url = `${API_BASE_URL}/import-u8/export?year=${year}&business_type=${encodeURIComponent(businessType)}&company=${encodeURIComponent(company)}&token=${token}`;
    if (month !== undefined && month !== null) {
      url += `&month=${month}`;
    }
    return url;
  },

  exportExcel: async (year: number, businessType: string, company: string, month?: number): Promise<void> => {
    const token = localStorage.getItem('access_token');
    let url = `${API_BASE_URL}/import-u8/export?year=${year}&business_type=${encodeURIComponent(businessType)}&company=${encodeURIComponent(company)}`;
    if (month !== undefined && month !== null) {
      url += `&month=${month}`;
    }
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!response.ok) {
      throw new Error('导出失败');
    }

    const contentType = response.headers.get('content-type') || '';
    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;

    if (contentType.includes('zip')) {
      const disposition = response.headers.get('content-disposition') || '';
      const match = disposition.match(/filename\*?=UTF-8''(.+)/);
      a.download = match ? decodeURIComponent(match[1]) : `凭证_${businessType}_${year}.zip`;
    } else {
      const monthSuffix = month ? `_${String(month).padStart(2, '0')}月` : '';
      a.download = `凭证_${businessType}_${year}${monthSuffix}.xlsx`;
    }

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(objectUrl);
  },

  getHistory: async (params?: {
    page?: number;
    page_size?: number;
    year?: number;
    business_type?: string;
    company?: string;
  }): Promise<U8ImportHistoryResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set('page', String(params.page));
    if (params?.page_size) searchParams.set('page_size', String(params.page_size));
    if (params?.year) searchParams.set('year', String(params.year));
    if (params?.business_type) searchParams.set('business_type', params.business_type);
    if (params?.company) searchParams.set('company', params.company);
    const qs = searchParams.toString();
    const url = `/import-u8/history${qs ? `?${qs}` : ''}`;
    const response = await apiClient.get<U8ImportHistoryResponse>(url);
    return response.data;
  },
};
